"use client";

import { useTranslations } from "next-intl";
import React, { ComponentPropsWithRef, FC, forwardRef, memo, useEffect, useRef } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";

import { controlledCheckbox } from "@/components/ui/Form/Filters/FilterUtils";
import Icon from "@/components/ui/Icon/Icon";

export interface IconBaseProps extends ComponentPropsWithRef<"input"> {
  name: string;
  filter: string;
  displayInSearchBar?: boolean;
  values?: (string | number)[] | undefined;
  field?: ControllerRenderProps;
  fieldState?: ControllerFieldState;
  availableValues?: (string | number)[] | undefined;
}

const formatValue = (value: string | number): string | number => {
  if (typeof value === "number") {
    return value;
  }

  const cleaned = value.replace(/&/g, "").trim();
  const words = cleaned.split(/\s+/);

  return words.length === 1 ? cleaned : words.join("-");
};

const IconBase = forwardRef<HTMLInputElement, IconBaseProps>(
  ({ name, filter, displayInSearchBar = false, field, fieldState, values, availableValues, ...rest }, ref) => {
    const t = useTranslations();
    const checkboxes = useRef<(HTMLInputElement | null)[]>([]);
    return (
      <div className={`grid grid-cols-3 w-fit pb-m px-m gap-xs ${displayInSearchBar ? "md:pb-0 md:px-0 w-[120px]" : ""}`}>
        {values?.map((value, index) => {
          const filedUID = `filter-${name}-${value}`;
          return (
            <div className="" key={filedUID}>
              <input
                ref={(el) => {
                  checkboxes.current[index] = el;
                }}
                {...rest}
                id={filedUID}
                className="appearance-none hidden"
                type="checkbox"
                checked={field?.value?.includes(value as string) ?? false}
                value={value}
                onChange={(event) => controlledCheckbox(field, event)}
                //disabled={availableValues && availableValues.length > 0 ? !availableValues?.includes(value) : false}
              />
              <label
                className={`${availableValues && availableValues.length > 0 && availableValues?.includes(value) ? "cursor-pointer" : "cursor-pointer"} aspect-square w-auto transition-colors border border-gray-20 rounded-lg px-l py-[6px] flex flex-col items-center text-center justify-center text-s ${field?.value?.includes(value as string) ? "bg-gold-gradient" : ""}`}
                htmlFor={filedUID}
              >
                <Icon className="stroke-black block" name={t(`filter.icon.${name}.${formatValue(value) as string}`)} size="48" />
                {t(`filter.label.${name}-${formatValue(value) as string}`)}
              </label>
            </div>
          );
        })}
      </div>
    );
  },
);
IconBase.displayName = "IconBase";
export default IconBase;

/* export default memo(IconBase, (oldArgs, newArgs) => {
  const prevField = JSON.stringify(oldArgs.field);
  const prevValues = JSON.stringify(oldArgs.values);
  const nextField = JSON.stringify(newArgs.field);
  const nextValues = JSON.stringify(newArgs.values);
  return prevField === nextField && prevValues === nextValues;
}); */
